import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { getAgents } from '../actions/getAgents';

export const getAgentsQueryKey = (sourcedId: string) => ['agents', sourcedId];

export const getAgentsQueryOptions = (sourcedId: string) => {
  return queryOptions({
    queryKey: getAgentsQueryKey(sourcedId),
    staleTime: 0, // always fetch fresh data

    placeholderData: keepPreviousData, // don't have 0 rows flash while changing pages/loading next page
    queryFn: async () => {
      const response = await getAgents({
        data: {
          sourcedId,
        },
      });

      if (!response.success || response.error) {
        throw new Error(response.error || 'Unknown error');
      }

      return response.data;
    },
  });
};

export const useGetAgents = (sourcedId: string) =>
  useQuery(getAgentsQueryOptions(sourcedId));
